import axios from 'axios';
import getUnauthenticatedApiClient from './getUnauthenticatedApiClient';
import urlcat from 'urlcat';

type ApiResponse = {
  response: any;
  hasError: boolean;
  error: object;
  success: boolean;
};

export class UnauthenticatedApiService {
  /** Creates a single instance of the class */
  private static _instance: UnauthenticatedApiService = new UnauthenticatedApiService();
  /** Documentation on abort controller usage: https://axios-http.com/docs/cancellation  */
  private static _abortController: AbortController = new AbortController();

  constructor() {
    // Make sure we don't create more than one instance of this service
    if (UnauthenticatedApiService._instance) {
      return UnauthenticatedApiService._instance;
    }
  }

  public get = async (url: string, params: object): Promise<ApiResponse> => {
    const apiClient = await getUnauthenticatedApiClient();

    if (apiClient && url) {
      return await apiClient
        .get(urlcat(process.env.API_BASE_URL as string, url, params), {
          signal: UnauthenticatedApiService._abortController.signal,
        })
        .then(function (response) {
          return {
            response: response?.data,
            hasError: false,
            error: undefined,
            success: true,
          };
        })
        .catch(function (error) {
          if (!axios.isCancel(error)) {
            return {
              response: undefined,
              hasError: true,
              error: error?.data,
              success: false,
            };
          }
        });
    }
  };

  public post = async (url: string, params: object, requestBody: object): Promise<ApiResponse> => {
    const apiClient = await getUnauthenticatedApiClient();

    if (apiClient && url) {
      return await apiClient
        .post(urlcat(process.env.API_BASE_URL as string, url, params), requestBody, {
          signal: UnauthenticatedApiService._abortController.signal,
        })
        .then(function (response) {
          return {
            response: response?.data,
            hasError: false,
            error: undefined,
            success: true,
          };
        })
        .catch(function (error) {
          if (!axios.isCancel(error)) {
            return {
              response: undefined,
              hasError: true,
              error: error?.data,
              success: false,
            };
          }
        });
    }
  };

  public put = async (url: string, params: object, requestBody: object): Promise<ApiResponse> => {
    const apiClient = await getUnauthenticatedApiClient();

    if (apiClient && url) {
      return await apiClient
        .put(urlcat(process.env.API_BASE_URL as string, url, params), requestBody, {
          signal: UnauthenticatedApiService._abortController.signal,
        })
        .then(function (response) {
          return {
            response: response?.data,
            hasError: false,
            error: undefined,
            success: true,
          };
        })
        .catch(function (error) {
          if (!axios.isCancel(error)) {
            return {
              response: undefined,
              hasError: true,
              error: error?.data,
              success: false,
            };
          }
        });
    }
  };
}
